import generateQuery from '@/libs/generate-query'
import HttpRequest from './HttpRequest'

class CompanyCenterProvider extends HttpRequest {
  findAll () {
    return this.get('/call-category')
  }

  findAllCallCategory () {
    return this.get('/call-category/category/all')
  }

  createGroup (payload) {
    return this.post('/call-category', payload)
  }

  updateGroup (id, payload) {
    return this.patch(`/call-category/${id}`, payload)
  }

  deleteGroup (id) {
    return this.delete(`/call-category/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/call-category?page=${page}&limit=${limit}${generateQuery(query)}`)
  }
}

export default CompanyCenterProvider
